import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
	<QueryClientProvider client={new QueryClient()}>
		<App />
		<ReactQueryDevtools />
	</QueryClientProvider>
);

